module.exports = __WEBPACK_EXTERNAL_MODULE_81__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display/Bitmap","root":["openfl","display","Bitmap"],"commonjs":"openfl/display/Bitmap","commonjs2":"openfl/display/Bitmap"}
// module id = 81
// module chunks = 0